var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSelect, IconButton } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { change, Field } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { FlowType } from 'fable/flowEditor';
import { MATCH_BOOLEAN_DEFAULT_VALUE } from '../../constants';
import { MatchingOperator, MatchingSystemType, VariableScope, } from '../../nodeTypes/types';
import { ConditionVarSelector } from './conditionVariableSelector';
import styles from './fieldConditionComponent.module.scss';
import { getMatchComponent, getOperatorOptions, } from './fieldConditionComponent/';
const BOOLEAN_VARIABLE_TYPES = [
    MatchingSystemType.AGENT_HAS_REPLIED,
    MatchingSystemType.AGENT_HAS_REPLIED_TRIGGER,
    MatchingSystemType.USER_HAS_REPLIED,
    MatchingSystemType.USER_HAS_REPLIED_TRIGGER,
];
class FieldConditionComponentImpl extends PureComponent {
    componentDidUpdate(prevProps) {
        var _a, _b;
        const { changeMatchVariable, changeOperator, rules, index } = this.props;
        const { rules: prevRules, index: prevIndex } = prevProps;
        const currentRule = rules === null || rules === void 0 ? void 0 : rules[index];
        const prevRule = prevRules === null || prevRules === void 0 ? void 0 : prevRules[prevIndex];
        const currentOptions = getOperatorOptions(currentRule.variable);
        const currentOperatorExists = currentOptions.find((opt) => opt.id === currentRule.operator);
        // If variable was changed and the selected operator is not supported,
        // then change operator to one that is supported
        if (!currentOperatorExists && currentOptions[0]) {
            changeOperator(currentOptions[0].id);
        }
        const prevVariableType = (_a = prevRule.variable) === null || _a === void 0 ? void 0 : _a.variableType;
        const variableType = (_b = currentRule.variable) === null || _b === void 0 ? void 0 : _b.variableType;
        // variableType changes reset to default matchValues
        if (variableType && prevVariableType !== variableType) {
            changeMatchVariable({
                scope: VariableScope.INPUT,
                values: BOOLEAN_VARIABLE_TYPES.includes(variableType)
                    ? [MATCH_BOOLEAN_DEFAULT_VALUE]
                    : [],
            });
        }
    }
    handleRemoveRow() {
        const { onRemove, index } = this.props;
        analytics.flowActionConditionRemoved({
            flowType: FlowType.FLOW_TYPE_AUTOMATION,
        });
        onRemove(index);
    }
    render() {
        const { field, totalRows, index, variables, rules } = this.props;
        const currentRule = rules === null || rules === void 0 ? void 0 : rules[index];
        const showMatchField = ![
            MatchingOperator.IS_EMPTY,
            MatchingOperator.IS_NOT_EMPTY,
        ].includes(currentRule.operator);
        const MatchComponent = getMatchComponent(currentRule.variable);
        return (_jsxs("div", Object.assign({ className: styles.rulesRow }, { children: [_jsxs("div", Object.assign({ className: styles.ruleInputs }, { children: [_jsxs("div", Object.assign({ className: styles.ruleInputsFirst }, { children: [_jsx(Field, { component: ConditionVarSelector, name: `${field}.variable`, className: styles.ruleInputVariable, required: true, placeholder: "Select variable", variables: variables }), _jsx(Field, { name: `${field}.operator`, component: FieldSelect, className: styles.ruleInputMatchingrule, required: true, items: getOperatorOptions(currentRule.variable), dropdownProps: {
                                        fixed: true,
                                    }, noLabel: true, noAlert: true })] })), showMatchField && MatchComponent && (_jsx("div", Object.assign({ className: styles.ruleInputsSecond }, { children: _jsx(Field, { component: MatchComponent, name: `${field}.match`, className: styles.ruleInputMatch, required: true, placeholder: "Input or variable", variables: variables, allowFreetext: true }) })))] })), _jsx("div", Object.assign({ className: styles.ruleActions }, { children: _jsx(IconButton, { icon: "trash", variant: "danger", disabled: totalRows === 1, onClick: this.handleRemoveRow }) }))] })));
    }
}
__decorate([
    boundMethod
], FieldConditionComponentImpl.prototype, "handleRemoveRow", null);
export const FieldConditionComponent = connect(undefined, (dispatch, ownProps) => {
    const { field, meta } = ownProps;
    const matchFieldName = `${field}.match`;
    const operatorFieldName = `${field}.operator`;
    return {
        changeMatchVariable: (matchVariable) => dispatch(change(meta.form, matchFieldName, matchVariable)),
        changeOperator: (operatorValue) => dispatch(change(meta.form, operatorFieldName, operatorValue)),
    };
})(FieldConditionComponentImpl);
